document.addEventListener("DOMContentLoaded", function () {
  // Top-level nav items
  const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");
  let activeMenuItem = null;

  menuItems.forEach((item) => {
    const detailsElement = item.querySelector("details");
    if (!detailsElement) return;

    item.addEventListener("mouseenter", () => {
      if (activeMenuItem && activeMenuItem !== item) {
        const previousDetailsElement = activeMenuItem.querySelector("details");
        if (previousDetailsElement) {
          previousDetailsElement.removeAttribute("open");
        }
      }
      detailsElement.setAttribute("open", true);
      activeMenuItem = item;
    });

    item.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!item.matches(":hover")) {
          detailsElement.removeAttribute("open");
          if (activeMenuItem === item) activeMenuItem = null;
        }
      }, 500);
    });
  });

  // 2nd-level flyout items — open nested submenu on hover
  const subMenuItems = document.querySelectorAll(
    '.header__submenu.list-menu--disclosure > li'
  );

  subMenuItems.forEach((item) => {
    const details = item.querySelector('details[id^="Details-HeaderSubMenu"]');
    if (!details) return;

    item.addEventListener("mouseenter", () => {
      // Close any other open sibling flyouts
      const siblings = item.parentElement.querySelectorAll(
        'details[id^="Details-HeaderSubMenu"][open]'
      );
      siblings.forEach((s) => {
        if (s !== details) s.removeAttribute("open");
      });
      details.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!item.matches(":hover")) {
          details.removeAttribute("open");
        }
      }, 150);
    });
  });
});
